import { render } from "./IssueReportPrompt.vue?vue&type=template&id=17704696&scoped=true"
import script from "./IssueReportPrompt.vue?vue&type=script&lang=js"
export * from "./IssueReportPrompt.vue?vue&type=script&lang=js"

import "./IssueReportPrompt.vue?vue&type=style&index=0&id=17704696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17704696"]])

export default __exports__